module.exports = __webpack_public_path__ + "img/confirmed.01a6829b.png";